"use client";

import { useState } from "react";
import { useAuth } from "@/contexts/auth-context";

export function CancelSubscriptionButton() {
  const [loading, setLoading] = useState(false);
  const { refreshUserSubscription } = useAuth();

  const handleCancel = async () => {
    const ok = window.confirm(
      "Confirm cancellation? Your subscription will remain until the billing period ends."
    );
    if (!ok) return;

    try {
      setLoading(true);
      const res = await fetch("/api/stripe/cancel", { method: "POST" });
      if (!res.ok) {
        throw new Error("Cancel failed");
      }
      // 主动刷新（SSE 也会推送，双保险）
      await refreshUserSubscription();
    } catch (e) {
      alert("Something went wrong, please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleCancel}
      disabled={loading}
      className="rounded-lg text-xs border pl-2 px-2 py-1 text-gray-900 bg-gray-200 dark:text-white dark:bg-gray-700"
    >
  {loading ? "Processing…" : "Cancel"}
    </button>
  );
}
